import { css } from '@emotion/react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const MyAccountLayoutDesktopTab = ({ active, activeTabRef, label, path }) => (
    <li>
        <Link
            css={({ orangeDefault, black, silverLightest, silverLight }) => css`
                box-sizing: border-box;
                width: 100%;
                display: flex;
                align-items: center;
                padding-top: 0.6667rem;
                padding-bottom: 0.6667rem;
                padding-left: 3rem;
                padding-right: 0.6667rem;
                border-left: solid 0.3333rem ${active ? orangeDefault : 'transparent'};
                background-color: ${active ? silverLightest : 'transparent'};
                font-size: 1.1667rem;
                font-weight: ${active ? '700' : '400'};
                text-decoration: none;
                color: ${black};
                outline: none;
                hyphens: auto;
                min-width: 0;

                &:hover,
                &:focus-visible {
                    font-weight: 700;
                    border-left: solid 0.3333rem ${active ? orangeDefault : black};
                    background-color: ${silverLight};
                }
            `}
            aria-current={active ? 'page' : undefined}
            ref={activeTabRef}
            to={path}
        >
            {label}
        </Link>
    </li>
);

MyAccountLayoutDesktopTab.propTypes = {
    active: PropTypes.bool,
    activeTabRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    label: PropTypes.string,
    path: PropTypes.string,
};

export default MyAccountLayoutDesktopTab;
